interface Route {
  name: string;
  path: string;
  exact?: boolean;
}
export const appName = process.env.REACT_APP_NAME;
export const version = process.env.REACT_APP_VERSION;

export const routes: Route[] = [
  {
    name: "home",
    path: "/",
    exact: true,
  },
  {
    name: "products",
    path: "/products",
  },
  {
    name: "folder",
    path: "/folder",
  },
  {
    name: "contact",
    path: "/contact",
  },
];
